export default "__VITE_ASSET__BH2zt6eD__"